/* eslint-disable */
import {
    Card,
    CardContent,
    CircularProgress,
    Grid,
    RACTable,
    RACTableCell,
    RACTableRow,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { ZoneBasedPricingContext } from './ZoneBasedPricingContext';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { sortArray } from '../../../constants/constants';
import { ReactComponent as NorecordsIcon } from "../../../assets/images/No-records.svg";
import { ReactComponent as Alert } from "../../../assets/images/Alert.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/Edit Icon.svg";
import ReactPaginate from 'react-paginate';
import { ReactComponent as SortIconDown } from "../../../assets/images/sort-icon.svg";
import { ReactComponent as SortIconUp } from "../../../assets/images/sort-icon-up.svg";
import { CostPricingRuleDetail, Headers } from '../../shared/interface/CostBasedPricingInterface';
import { ZoneBasedPricingGridContent } from '../../shared/interface/ZoneBasedPricingInterface';

export default function ZoneBasedPricingGrid(props?: any) {
    const classes = CostBasedPricingStyles();
    const { pageDisplay, loader, zoneBasedPricingGridContent, setFormProps,
        setDisplayForm, gridHeaders, setGridHeaders, setZoneBasedPricingGridContent,
        totalRowCount, pageNumber, setPageNumber, pageCount, searchZoneBasedPricingDetails,
        userInfo, setHandlePopup, errorMessage, setErrorMessage
    } = useContext(ZoneBasedPricingContext);

    const formatDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split('-');
        return `${month}/${day}/${year}`;
    };

    function editRow(obj: ZoneBasedPricingGridContent) {
        const props = {
            zoneNumber: obj?.zoneNumber ? [obj?.zoneNumber] : '',
            departmentNumber: obj?.departmentNumber || '',
            subdepartmentNumber: obj?.subdepartmentNumber || '',
            bracketNumber: obj?.bracketNumber || '',
            termPrem: obj?.termPrem || '',
            turn: obj?.turn ? parseFloat(obj.turn).toString() : '',
            reCalculateTerm: obj?.reCalculateTermFlag ? obj?.reCalculateTermFlag == 'YES' ? 'Yes' : '' : '',
            newAndUsedRatePrem: obj?.newAndUsedRatePrem || '',
            brandNewRatePrem: obj?.brandNewRatePrem || '',
            startDate: obj.startDate || '',
            endDate: obj.endDate || '',
        };
        setFormProps(props)
        setDisplayForm(true)
        setErrorMessage({
            ...errorMessage,
            startDate: '',
            endDate: '',
            minRatePct: '',
            maxRatePct: '',
            minRateNew: '',
            maxRateNew: '',
            minRateUsed: '',
            maxRateUsed: '',
            termMax: ''
        })
    }

    function returnValue(value: string | null, type?: any) {
        if (type == 'flag') {
            return value ? value == 'YES' ? 'Yes' : value == 'NO' ? 'No' : value : '-'
        } else if (type == 'dollar') {
            return value ? `$${value}` : '-'
        } else if (type == 'decimel') {
            return value ? parseFloat(value).toString() : '-'
        } else if (type == 'date') {
            return value ? formatDate(value) : '-'
        }
        return value ? value : '-'
    }

    const renderZoneBasedPricingTableHeadFn = () => (
        <>
            {gridHeaders.map((item: Headers, index: number) => {
                return (
                    <RACTableCell>
                        {" "}
                        {item.isSortable == true ? (
                            <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    sortArray(
                                        gridHeaders[index].key,
                                        index,
                                        gridHeaders,
                                        zoneBasedPricingGridContent,
                                        (item.key == 'endDate' || item.key == 'startDate') ? 'date' :
                                            item.key == 'reCalculateTerm' ? 'string' : 'number',
                                        setGridHeaders,
                                        setZoneBasedPricingGridContent
                                    );
                                }}
                            >
                                {" "}
                                {item.heading + " "}{" "}
                                {item.isSorted == true ? (
                                    item.sortDirection == "DESC" ? (
                                        <SortIconUp className={classes.ml2} />
                                    ) : (
                                        <SortIconDown className={classes.ml2} />
                                    )
                                ) : null}
                            </a>
                        ) : (
                            item.heading + " "
                        )}{" "}
                    </RACTableCell>);
            })}
        </>
    );
    const renderZoneBasedPricingTableContentFn = () => (
        <>
            {loader.contentLoader ? (
                <RACTableRow>
                    <Grid className={classes.gridLoader}>
                        <Grid className={classes.textSpaceNorecords}>
                            <Grid className={classes.textcenterImage}>
                                <CircularProgress />
                            </Grid>
                        </Grid>
                    </Grid>
                </RACTableRow>
            ) : null}
            {pageDisplay == 200 ? zoneBasedPricingGridContent?.map((obj: ZoneBasedPricingGridContent, index: number) => {
                return (
                    <RACTableRow key={index} className={classes.whitebackground} style={{ width: '100%' }}>
                        <RACTableCell>{returnValue(obj?.zoneNumber)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.departmentName)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.subdepartmentName)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.bracketName)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.newAndUsedRatePrem, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.brandNewRatePrem, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.turn, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.termPrem)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.reCalculateTermFlag, 'flag')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.startDate, 'date')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.endDate, 'date')}</RACTableCell>
                        <RACTableCell style={{
                            width: "42px",
                            height: "45px",
                            cursor: "pointer",
                        }} >
                            <EditIcon onClick={() => {
                                if (userInfo.hasEditAccess) {
                                    editRow(obj)
                                } else {
                                    setHandlePopup({ isOpen: true, Content: 'This feature is currently restricted to this User', index: 0, type: 'error' });
                                }
                            }} />
                        </RACTableCell>
                    </RACTableRow>
                )
            }) : pageDisplay == 204 ? (
                <RACTableRow>
                    <Grid className={classes.gridLoader}>
                        <Grid className={classes.textSpaceNorecords}>
                            <Grid className={classes.textcenterImage1}>
                                <NorecordsIcon />
                                <Typography> No Records Found !</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </RACTableRow>
            ) : pageDisplay == 400 || pageDisplay == 500 ? (
                <RACTableRow>
                    <Grid className={classes.gridLoader}>
                        <Grid className={classes.textSpaceNorecords}>
                            <Grid className={classes.textcenterImage1}>
                                <Alert style={{ width: '30px', height: '30px' }} />
                                <Typography> Something Went Wrong !</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </RACTableRow>
            ) : null}
        </>
    );

    const renderTable = () => (
        <>
            <RACTable
                renderTableHead={renderZoneBasedPricingTableHeadFn}
                renderTableContent={renderZoneBasedPricingTableContentFn}
                style={{
                    width: "100%",
                    whiteSpace: "nowrap",
                }}
                className={classes.pricingGrid}
            />
        </>
    );

    const handlePageClick = (event: any) => {
        setPageNumber(event.selected);
        searchZoneBasedPricingDetails((event.selected + 1).toString());
    };

    return (
        <Grid container md={12} >
            <Card style={{ borderRadius: '12px', marginBottom: '4%', position: 'relative', width: '100%' }}>
                <CardContent style={{ paddingBottom: '0px', paddingRight: '30px' }}>
                    <Grid
                        style={{
                            width: "100%",
                            overflowX: "auto",
                            maxHeight: "63vh",
                            minHeight: loader.contentLoader ? '38vh' : '61vh'
                        }}
                    >
                        {renderTable()}
                    </Grid>
                    {totalRowCount ? (<Grid className={` ${classes.textRight}`}>
                        <Grid className={`${classes.floatLeft}`}>

                            <Typography>
                                # of Records:&nbsp;
                                {pageNumber == 0
                                    ? totalRowCount < 25 ? totalRowCount : 25 * 1
                                    : (pageNumber + 1) == pageCount
                                        ? totalRowCount
                                        : (pageNumber + 1) * 25}
                                /{totalRowCount}
                            </Typography>
                        </Grid>

                        <ReactPaginate
                            nextLabel=">"
                            onPageChange={handlePageClick}
                            pageCount={pageCount}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={0}
                            disableInitialCallback={true}
                            previousLabel="<"
                            breakLabel=""
                            initialPage={pageNumber}
                            pageClassName={classes.pagination}
                            pageLinkClassName={classes.pagelink}
                            previousLinkClassName={
                                pageNumber === 0
                                    ? classes.paginationprevnextdisable
                                    : classes.paginationprevnext
                            }
                            nextLinkClassName={
                                pageNumber === pageCount - 1
                                    ? classes.paginationprevnextdisable
                                    : classes.paginationprevnext
                            }
                            breakClassName={classes.pagination}
                            breakLinkClassName={classes.pagination}
                            containerClassName={classes.pagination}
                            activeClassName={classes.pageactive}
                            forcePage={pageNumber === 0 ? 0 : undefined}
                        />

                    </Grid>) : null}
                </CardContent>
            </Card>
        </Grid>
    );
}
